export type CsvEncoding = "utf8" | "sjis";

const isFlagEnabled = (key: string): boolean => {
  const value = import.meta.env[key];
  return value === "true" || value === true;
};

const readDefaultCsvEncoding = (): CsvEncoding => {
  const value = import.meta.env.VITE_DEFAULT_CSV_ENCODING;
  return value === "utf8" ? "utf8" : "sjis";
};

export const config = {
  useFixedTicketFields: isFlagEnabled("VITE_USE_FIXED_TICKET_FIELDS"),
  useFixedUserFields: isFlagEnabled("VITE_USE_FIXED_USER_FIELDS"),
  enableProductLabelCleanup: isFlagEnabled("VITE_ENABLE_PRODUCT_LABEL_CLEANUP"),
  enableIndustryFilter: isFlagEnabled("VITE_ENABLE_INDUSTRY_FILTER"),
  enableInternalOrgExclusion: isFlagEnabled(
    "VITE_ENABLE_INTERNAL_ORG_EXCLUSION",
  ),
  defaultCsvEncoding: readDefaultCsvEncoding(),
};
